import keyBy from 'lodash/keyBy';

export const REPORT_TEAMS_FETCH_LIMIT = 25;

export const REPORTS_VIEW_TYPES = {
  TEAMS: 'customers',
  INACTIVE_TEAMS: 'inactive_customers',
  DEACTIVATED_TEAMS: 'deactivated_customers',
  COUNT_STATISTICS: 'counts_statistics',
};

export const DEFAULT_REPORTS_VIEW_TYPES = REPORTS_VIEW_TYPES.COUNT_STATISTICS;

export const REPORTS_VIEW_TYPES_ARRAY = [
  {
    label: 'Teams Overview',
    value: REPORTS_VIEW_TYPES.COUNT_STATISTICS,
  },
  {
    label: 'Customers',
    value: REPORTS_VIEW_TYPES.TEAMS,
  },
  {
    label: 'Inactive Customers',
    value: REPORTS_VIEW_TYPES.INACTIVE_TEAMS,
  },
  {
    label: 'Deactivated Customers',
    value: REPORTS_VIEW_TYPES.DEACTIVATED_TEAMS,
  },
];

export const REPORTS_VIEW_TYPES_HASH = keyBy(REPORTS_VIEW_TYPES_ARRAY, 'value');
